export const CLOSE_ICON = 'CLOSE ICON'
export const CLOSE_SLATE = 'CLOSE SLATE'
export const CLOSE_SLATE_14PX = 'CLOSE SLATE 14PX'
export const CLOSE_BLUE = 'CLOSE BLUE'
export const ELLIPSIS = 'ELLIPSIS'
export const ERROR_ICON = 'IMG ERROR'
export const PAGING_ENABLED = 'PAGING ENABLED'
export const PAGING_DISABLED_LEFT = 'PAGING DISABLED LEFT'
export const PAGING_DISABLED_RIGHT = 'PAGING DISABLED RIGHT'
export const PAGING_HOVER = 'PAGING HOVER'
export const PAGING_SIZE = 9
export const SEARCH_ICON = 'SEARCH ICON'
export const SEARCH_ICON_WHITE = 'SEARCH ICON WHITE'
export const SEARCH_ICON_HOVER = 'SEARCH ICON HOVER'
export const SMEX_LOGO = 'SMEX LOGO'
export const SLSO_LOGO = 'SLSO_LOGO'
export const LOCK_ICON = 'LOCK ICON'
export const STD_CHECKED = 'STD CHECKED'
export const STD_UNCHECKED = 'STD UNCHECKED'
export const LRG_CHECKED = 'LRG CHECKED'
export const LRG_UNCHECKED = 'LRG UNCHECKED'
export const FILTER_WHITE = 'FILTER WHITE'
export const FILTER_SLATE = 'FILTER SLATE'
export const ERROR_INFO_ICON = 'ERROR INFO ICON'
export const ERROR_ICON_PREVIEWER = 'ERROR ICON PREVIEWER'
export const IMAGE_NOT_FOUND = 'IMAGE NOT FOUND'
export const IMAGE_NOT_FOUND_THUMBNAIL = 'IMAGE NOT FOUND THUMBNAIL'
export const BLANK_IMAGE = 'BLANK IMAGE'
export const GENERIC_AVATAR = 'GENERIC AVATAR'
export const SHARE_ICON_WHITE = 'SHARE ICON WHITE'
export const SHARE_ICON_WHITE_LARGE = 'SHARE ICON WHITE LARGE'
export const SHARE_ICON_BLUE = 'SHARE ICON BLUE'
export const NOTEBOOK_ICON = 'NOTEBOOK ICON'
export const WARNING_ICON_WHITE_LARGE = 'WARNING ICON WHITE LARGE'
export const WARNING_ICON_GREY = 'WARNING ICON GREY'
export const WARNING_ICON_ORANGE = 'WARNING ICON ORANGE'
export const DOCUMENT_APPROVE = 'DOCUMENT APPROVE'
export const FILE_EXCHANGE = 'FILE EXCHANGE'
export const DROPDOWN_CLOSED = 'DROPDOWN CLOSED'
export const DROPDOWN_OPEN = 'DROPDOWN OPEN'
export const PLUS = 'PLUS'
export const PLUS_BLUE = 'PLUS BLUE'
export const LRG_ERRORS_UNCHECKED = 'LRG ERRORS UNCHECKED'
export const NO_SHARED_RESOURCES = 'NO SHARED RESOURCES'
export const NO_PENDING_RESOURCES = 'NO PENDING RESOURCES'
export const NO_DECLINED_RESOURCES = 'NO DECLINED RESOURCES'
export const SUCCESS_TOAST = 'SUCCESS TOAST'
export const DECLINED_RESOURCES_CARD = 'DECLINED RESOURCES CARD'
export const DECLINED_MENU_INDICATOR = 'DECLINED MENU INDICATOR'
export const APPROVED_MENU_INDICATOR = 'APPROVED MENU INDICATOR'
export const PENDING_MENU_INDICATOR = 'PENDING MENU INDICATOR'
export const WARNING_RED_ICON = 'WARNING RED ICON'
export const EDIT_PEN = 'EDIT PEN'
export const EDIT_PEN_HOVER = 'EDIT PEN HOVER'
export const SMEX_MOBILE_LOGO = 'SMEX MOBILE LOGO'
export const NEW_ICON = 'NEW ICON'
export const NEW_ICON_LEFT = 'NEW ICON LEFT'
export const NEW_LOOK = 'NEW LOOK'
export const NEW_RESOURCES = 'NEW RESOURCES'
export const SAVE_ONLINE = 'SAVE ONLINE'
export const LEARN_MORE = 'LEARN MORE'
export const GETPROFILE_FIELDS = ['resourceType', 'fileName', 'defaultPreviewUrl', 'rawResourceUrl', 'previews', 'uploadedBy', 'uploadedDate', 'subjects', 'source', 'grades', 'tags', 'author', 'title', 'description', 'clientPlatform', 'componentTypes', 'lpp', 'country', 'language', 'standardSets', 'standardStrands', 'externalFlags']
export const TRIANGLE_ICON = 'TRIANGLE ICON'
export const CANCEL_BLACK = 'CANCEL BLACK'
export const CANCEL_HOVER = 'CANCEL HOVER'
export const LEGACY_SIGN_IN = 'LEGACY SIGN IN'
export const ID_SMART_LOGO = 'ID_SMART_LOGO'
export const ID_FOOTER = 'ID_FOOTER'
export const SEARCH_ICON_SIGN_IN_MODAL = 'SEARCH ICON SIGN IN MODAL'
export const CLOUD_ICON_SIGN_IN_MODAL = 'CLOUD ICON SIGN IN MODAL'
export const LINK_STYLE = 'color: #017db7; font-weight: bold;'
export const INFO = 'INFO'
export const INFO_HOVER = 'INFO_HOVER'
export const NJCTL = 'njctl'
export const COMBINED_SHAPE = 'COMBINED SHAPE'
export const ICON_INFO = 'ICON INFO'
export const RIGHT_ENABLED = 'RIGHT ENABLED'
export const STUDENT_DEVICES = 'STUDENT DEVICES'
export const DEVICE_ICON = 'DEVICE ICON'
